import React from "react";
import { Outlet } from "react-router-dom";

export const RefundOutlet = () => {
  return <Outlet />;
};
